/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */


/**
 * Indicates the field to use for sorting the data:
 *   * SUBSCRIPTION_NAME
 *   * SUBSERVICE_NAME
 */
export enum ServiceSortFieldName {
  SUBSCRIPTION_NAME = 'SUBSCRIPTION_NAME',
  SUBSERVICE_NAME = 'SUBSERVICE_NAME'
}
